import styled from "@emotion/styled"

export const StyledPageContainer = styled.div`
  margin: 3rem auto 0;
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    margin: 5rem auto 0;
  }
`
